module.exports = __webpack_public_path__ + "static/media/48385002_2308758069199371_248805449707552768_o.c33beaee.jpg";